module.exports = __webpack_public_path__ + "static/media/my-visa-doc.9c816354.svg";